import type { Task } from "@gearbox-protocol/deploy-tools-shared";
import { ErrorBox, Loading } from "@gearbox-protocol/deploy-tools-ui";
import type { FC } from "react";
import { RouterTestsReport } from "./RouterTestsReport";
import useRouterTestResults from "./useRouterTestResults";
import useSDK from "./useSDK";

interface Props {
  task: Task;
}

export const TaskRouter: FC<Props> = ({ task }) => {
  const { loading, error, value: results } = useRouterTestResults(task);
  const { loading: sdkLoading, error: sdkError, value: sdk } = useSDK();

  if (loading || sdkLoading) {
    return <Loading />;
  }

  if (error || sdkError) {
    return <ErrorBox error={error || sdkError} />;
  }

  if (!results) {
    return <ErrorBox>Test results not found</ErrorBox>;
  }

  if (!sdk) {
    return <ErrorBox>SDK not found</ErrorBox>;
  }

  return <RouterTestsReport sdk={sdk} routerTestResults={results} />;
};
